import actions from './actions';
import { createReducer } from '../../helpers/reducer';
import { keyBy } from '../../helpers/core';

// ------------------------------
// Local util functions
// ------------------------------
function validate({ attr, value = '' }) {
  let error = '';

  if (attr === 'email') {
    const re = /^[^\s@]+@[^\s@]+.[^\s@]+$/;
    if (!re.test(value)) {
      error = 'Please enter a valid email';
    }
  }

  return error;
}

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  email: {
    value: '',
    error: validate({ attr: 'email' }),
    name: 'email',
    touched: false,
  },
  created: false,
  isSaveloader: false,
  error: '',
};

// ------------------------------
// Action Handlers
// ------------------------------
function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;

  state[attr] = {
    value,
    error: validate({ attr, value }),
    name: attr,
    touched: true,
  };

  return { ...state };
}

function onTouch(state, { payload }) {
  const { props } = payload;
  const propsArray = props.map(prop => state[prop]);

  const updatedState = keyBy(
    propsArray,
    prop => prop.name,
    prop => ({ ...prop, touched: true }),
  );

  return { ...state, ...updatedState };
}

function onClearState() {
  return {
    ...initState,
    email: {
      value: '',
      error: validate({ attr: 'email' }),
      name: 'email',
      touched: false,
    },
  };
}

function onForgotPasswordSuccess(state) {
  return {
    ...state,
    isSaveloader: false,
    created: true,
    error: '',
  };
}

function onForgotPasswordError(state, { payload }) {
  return {
    ...state,
    isSaveloader: false,
    created: true,
    error: payload.error,
  };
}

function onForgotPasswordRequest(state) {
  return {
    ...state,
    isSaveloader: true,
  };
}

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOUCH]: onTouch,
  [actions.CLEAR_STATE]: onClearState,
  [actions.FORGOT_PASSWORD_SUCCESS]: onForgotPasswordSuccess,
  [actions.FORGOT_PASSWORD_ERROR]: onForgotPasswordError,
  [actions.FORGOT_PASSWORD_REQUEST]: onForgotPasswordRequest,
});
